import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../core/_BLComponent.jsx';
import DragDropUpload from '../common/_DragDropUpload.jsx';
import {CustomAlert, CustomConfirm} from '../common/_Utilities.jsx';
import blAjax					from '../utils/_ajax.jsx';

export default class Accessibility extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.MAX_SIZE = 2097152;
		this.MAX_FILE_UPLOAD = 3;
		this.state = {
			firstname: '',
			lastname: '',
			emailAddress: blapp.session.getMe() ? blapp.session.getMe().skEmailAddr : '',
			countryId: blapp.session.getMe() ? blapp.session.codeCountryDetected : '',
			topic: 'Accessibility',
			message: '',
			isLoading: false,
			attemptToSubmit: 0
		}
	}

	render() {
		const isDisabled = !this.isReadyToSubmit();
		const invalidEmailAddr = ( this.state.emailAddress != "" &&  !blapp.util.isValidEmailAddr(this.state.emailAddress) );
		const isFirstnameMaxLength = (this.state.firstname.length == 40)?true:false;
		const isLastnameMaxLength = (this.state.lastname.length == 40)?true:false;
		const isMessageMaxLength = (this.state.message.length == 2000)?true:false;
		return (
			
			<div className="main l-margin-top">
				<div className="main__content">
					
					<h1 className="l-margin-bottom text--mxl-title l-border--bottom">Accessibility</h1>
					
					<section className="accessibility__section-main">
						<div className="accessibility__title l-margin-bottom--xl">
							Send feedback
						</div>
						<div className="accessibility__desc l-margin-bottom--xl">
							The LEGO Group is committed to ensuring effective communication and digital accessibility to all users. We are continually improving the user experience for everyone and apply the relevant accessibility standards to achieve these goals. We welcome your feedback on the accessibility of bricklink.com. Please let us know if you encounter accessibility barriers when accessing any area of our website.
						</div>
						
						<section className="accessibility__section-form">
							<div className="l-margin-bottom--xl">
								<div className="accessibility__section-name">
									<div className="accessibility__section-name-firstname">
										<div className="text--bold">First name</div>
										<div className="l-relative"> 
											<input className={"l-full-width text-input " + ( (isFirstnameMaxLength)?"contact-fields__field--error-no-pad":"" )} placeholder="First name" value={this.state.firstname} onChange={(e) => this.updateValue('firstname', e.target.value)} maxLength="40"/>
										</div>
										{isFirstnameMaxLength && <small className="l-margin-top--sm l-block text-color--primaryRed">40 characters max</small>}
									</div>
									
									<div className="accessibility__section-name-lastname">
										<div className="text--bold">Last name</div>
										<div className="l-relative"> 
											<input className={"l-full-width text-input " + ( (isLastnameMaxLength)?"contact-fields__field--error-no-pad":"" )} placeholder="Last name" value={this.state.lastname} onChange={(e) => this.updateValue('lastname', e.target.value)} maxLength="40"/>
										</div>
										{isLastnameMaxLength && <small className="l-margin-top--sm l-block text-color--primaryRed">40 characters max</small>}
									</div>
									
								</div>
							</div>

							<div className="l-margin-bottom--xl">
								<div className="text--bold">Email Address</div>
								<div className="l-relative"> 
									<input className={"text-input l-full-width" + (invalidEmailAddr ? ' contact-fields__field--error' : '')} placeholder="Email address" value={this.state.emailAddress} onChange={(e) => this.updateValue('emailAddress', e.target.value)}/>
									{invalidEmailAddr && <i className="fas fa-exclamation-triangle contact-fields__error-icon"/>}
								</div>
								{invalidEmailAddr && <small className="l-margin-top--sm l-block text-color--primaryRed">Please enter a valid email address.</small>}
							</div>

							<div className="l-margin-bottom--xl">
								<div className="text--bold">Message</div>
								<div><textarea className={"textarea l-full-width accessibility__text-area " + ( (isMessageMaxLength)?"contact-fields__field--error-no-pad":"" )} placeholder="Please enter details about your topic" value={this.state.message} onChange={(e) => this.updateValue('message', e.target.value)} maxLength="2000"/> </div>
								{isMessageMaxLength && <small className="l-block text-color--primaryRed">2,000 characters max</small>}
							</div>
							
							<button className="btn btn--cta text--bold" disabled={isDisabled} onClick={() => this.submit()}>Submit</button>
						</section>
					</section>
				</div>
			</div>
		);
	}

	isReadyToSubmit() {
		return (
			!blapp.util.isValidEmailAddr(this.state.emailAddress) || 
			this.state.emailAddress.trim() == '' || 
			this.state.message.trim() == '' || 
			this.state.isLoading ||
			this.state.firstname == '' ||
			this.state.lastname == ''
		)?false:true;
	}

	updateValue(type, value) {
		this.setState({[type]: value});
	}

	initInpFields( ) {
		this.setState({firstname:"", lastname:"", message:"", emailAddress: blapp.session.getMe() ? blapp.session.getMe().skEmailAddr : ''});
	}

	submitErr() {
		const message = (this.state.attemptToSubmit > 0) ? "Sorry, it seems like we're having some problems on our end. Please try again later." : "Oops! There was an error submitting your support ticket. Please try again.";
		this.triggerAlert(message);
	}

	submit() {
		this.setState({isLoading: true});
		const strFirstName = this.state.firstname;
		const strLastName = this.state.lastname;
		const strTopic = this.state.topic;
		const strEmail = this.state.emailAddress;
		const strMessage = this.state.message;
		const strCountryId = this.state.countryId;
		const req = {
			strFirstName   : strFirstName, 
			strLastName    : strLastName, 
			strEmail       : strEmail, 
			strCountryId   : strCountryId, 
			strTopic       : strTopic,
			strMessage     : strMessage 
		};
		blAjax.call(
			"/createHelpDeskTicket.ajax"
		,	req
		).then(
			( data ) =>
			{
				this.setState({isLoading: false});
				
				if (data.result == "EC_OK") {
					this.initInpFields();
					this.triggerConfirm();
					this.setState({attemptToSubmit: 0});
				} else {
					
					this.submitErr();
				}
			}
		).catch(
			( err ) =>
			{
				this.setState({isLoading: false});
				this.submitErr();
			}
		);

		/*
		blapp.models.fetch(
			"_send_support_request"
			, {
				controller: "support.BLCSupport"
				, method: "sendRequestToAdmin"
				, params: [this.state.emailAddress, subject, this.state.message, this.state.files]
				, refresh: true
			}
		).then(
			(data) => {
				this.setState({isLoading: false});
				if (data == "EC_OK") {
					this.initInpFields();
					this.triggerConfirm();
				} else {
					this.setState({isLoading: false})
					this.triggerAlert( "Something went wrong! Please try it again later: " + data );
				}
			}
		).catch(
			(err) => {
				//console.log(err)
				this.setState({isLoading: false});
				this.triggerAlert( "Something went wrong! Please try it again later!" );
			}
		);
		*/
		
	}

	triggerConfirm() {
		const confirmContent = '<h2 class="page-title l-margin-bottom--xl">Thank you for your submission!</h2><p class="l-margin-bottom--xl">We appreciate your feedback. Our Admin Team will review your submission.</p>';
		CustomAlert(confirmContent, "Done");
	}

	triggerAlert(message) {
		const confirmContent = `<i class="fas fa-exclamation-triangle l-margin-bottom accessibility__error-icon"></i><p class="l-margin-y--l">${message}</p>`;

		if (this.state.attemptToSubmit == 0 ) {		
			this.setState({attemptToSubmit: this.state.attemptToSubmit + 1});
			CustomConfirm(confirmContent, { 
				false:	'Cancel'
			,	true:	'Try again' 
			}, "", {buttonContainer: "accessibility__modal-button-container-retry", buttonTrue: "accessibility__modal-button", buttonFalse: "accessibility__modal-button"} )
			.then(value => {
				if(value == true) {
					this.submit();
				}
				else {
					this.setState({attemptToSubmit: 0});
				}
			});
		}
		else 
		{
			this.setState({attemptToSubmit: 0});
			CustomAlert(confirmContent, "Done");
		}
		
	}
};

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<Accessibility blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-main' )
						);
		blapp.refs.register( "main", elem );
	}
);
